/* ============================================================
   NORTHSHEEP — Collection custom filters engine (Size + Favourites + Sale + Colour pills)
   These are CLIENT-SIDE filters (favourites live in the browser; sizes are
   derived from the vendor), so to work across ALL pages like the native Price
   filter we load every page of the current (natively-filtered) view via the
   Section Rendering API, filter the whole set in the browser, and render the
   matches on one view — with removable pills and a live product count.
   State is kept per collection and resets when you move collections.
   ============================================================ */
(function () {
  'use strict';
  if (window.__nsColFiltersLoaded) return;
  window.__nsColFiltersLoaded = true;

  var ORDER = ['XS', 'S', 'M', 'L', 'XL', 'XXL', 'XXXL', 'XXXXL', 'XXXXXL'];
  // cm ranges shown next to each size label (must mirror ns-product-size-buckets).
  var RANGES = {
    cowhide: { M: '150-189', L: '190-209', XL: '210-219', XXL: '220-239', XXXL: '240-249', XXXXL: '250+' },
    sheepskin: { XS: '80-89', S: '90-99', M: '100-109', L: '110-119', XL: '120-129', XXL: '130-139', XXXL: '140-149', XXXXL: '150-159', XXXXXL: '160-169' }
  };
  function sizeDisplay(s, type) {
    var r = RANGES[type] && RANGES[type][s];
    return r ? (s + ' (' + r + ' cm)') : s;
  }
  var FAV_KEY = 'northsheep_fav_filter', SIZE_KEY = 'northsheep_size_filter';
  var HIDDEN_KEY = 'northsheep_hidden_filter';
  var COLOUR_KEY = 'northsheep_colour_filter';
  var SALE_KEY = 'northsheep_sale_filter';
  var CLOSE_SVG = '<svg viewBox="0 0 16 16" width="12" height="12" aria-hidden="true" focusable="false"><path d="M4 4l8 8M12 4l-8 8" stroke="currentColor" stroke-width="1.4" fill="none"/></svg>';

  function ssGet(k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } }
  function ssSet(k, v) { try { sessionStorage.setItem(k, v); } catch (e) {} }
  function esc(s) { return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }

  function curHandle() { var m = location.pathname.match(/\/collections\/([^/?#]+)/); return m ? m[1] : ''; }

  /* Filter state is read ONCE and memoised, not re-read per card.

     matches() runs for every card in the catalogue on every filter pass, and
     favOn() / sizeSel() / hiddenOn() each did a sessionStorage.getItem, a
     JSON.parse and a location.pathname regex. On a 160-product collection a
     single toggle therefore cost roughly 480 storage reads, 480 parses and 480
     regex matches — all of it recomputing three small values that cannot
     change while the pass is running. sessionStorage is synchronous, so that
     work lands on the main thread exactly when the grid is being rebuilt.

     Every write goes through setFav / setSize / setHidden, so invalidation is
     exact rather than time-based: those three drop the cache and the next read
     re-parses. sessionStorage is per-tab, so nothing else can change it
     underneath us. */
  var stateCache = null;
  function invalidateState() { stateCache = null; }
  function filterState() {
    if (stateCache) return stateCache;
    var h = curHandle(), fav = false, size = [], hid = false, colour = [], sale = false, o;
    try { o = JSON.parse(ssGet(FAV_KEY) || 'null'); fav = !!(o && o.h === h && o.on); } catch (e) {}
    // Only while this page has a Sale control: a Sale left on from a visit
    // before the merchant switched the filter off would otherwise empty the grid.
    if (document.querySelector('[data-ns-sale-filter]')) {
      try { o = JSON.parse(ssGet(SALE_KEY) || 'null'); sale = !!(o && o.h === h && o.on); } catch (e) {}
    }
    try { o = JSON.parse(ssGet(SIZE_KEY) || 'null'); size = (o && o.h === h && o.s && o.s.length) ? o.s : []; } catch (e) {}
    try { o = JSON.parse(ssGet(HIDDEN_KEY) || 'null'); hid = !!(o && o.h === h && o.on); } catch (e) {}
    /* Only while the pills run on THIS engine. When Shopify's own colour filter
       drives them (data-ns-native-pills, see ns-native-pills.js) the selection
       lives in the URL, and a colour remembered from an earlier visit would
       hide every card (they carry no data-ns-cols then) and read "0 products". */
    if (document.querySelector('[data-ns-colour-pills]')) {
      try { o = JSON.parse(ssGet(COLOUR_KEY) || 'null'); colour = (o && o.h === h && o.c && o.c.length) ? o.c : []; } catch (e) {}
    }
    stateCache = { fav: fav, size: size, hidden: hid, colour: colour, sale: sale };
    return stateCache;
  }

  function favOn() { return filterState().fav; }
  function setFav(on) { invalidateState(); ssSet(FAV_KEY, JSON.stringify({ h: curHandle(), on: !!on })); }
  /* Returns a COPY. One caller builds the next selection by mutating this
     array in place (push / splice) before writing it back, and handing out the
     cached array itself would let that edit the memoised state behind its
     back. matches() reads filterState().size directly instead, so the hot path
     still allocates nothing. */
  function sizeSel() { return filterState().size.slice(); }
  function setSize(arr) { invalidateState(); ssSet(SIZE_KEY, JSON.stringify({ h: curHandle(), s: arr })); }
  // ---- Colour pills: one pill = one colour collection; cards carry data-ns-cols ----
  function colourSel() { return filterState().colour.slice(); }
  function setColour(arr) { invalidateState(); ssSet(COLOUR_KEY, JSON.stringify({ h: curHandle(), c: arr })); }
  function cardCols(li) { var v = li.getAttribute('data-ns-cols'); return v ? v.split(' ') : []; }
  /* ONE CARD PER COLOUR (owner, 12 Oct 2026, the plaids: "keep them 1 product with 4 variants but then if they select
     plaid filter it turns into all lose products so they can see all plaids and all colours directly ... and then they
     land on the colour"). A pill switched to "Show every colour as its own card" (data-ns-split-colours) turns every
     card that lists its colours (data-ns-split, from the grid's Liquid) into one card per colour: that colour's photo,
     its name after the title, every link opening the product on that colour. Only while such a pill is on; the
     product stays one product. */
  function splitPills() {
    var out = [];
    document.querySelectorAll('[data-ns-colour-pill][data-ns-split-colours]').forEach(function (b) { out.push(b.getAttribute('data-ns-colour-pill')); });
    return out;
  }
  function splitOn() {
    var sp = splitPills(), sel = filterState().colour;
    for (var i = 0; i < sel.length; i++) if (sp.indexOf(sel[i]) !== -1) return true;
    return false;
  }
  function splitData(li) {
    var v = li.getAttribute('data-ns-split');
    if (!v) return null;
    try { var d = JSON.parse(v); return d && d.length > 1 ? d : null; } catch (e) { return null; }
  }
  function cdnWidth(u, w) { return u + (u.indexOf('?') === -1 ? '?' : '&') + 'width=' + w; }
  function colourCard(li, c) {
    var n = li.cloneNode(true);
    n.removeAttribute('data-ns-split');
    n.setAttribute('data-ns-split-colour', c.c);
    // ids must stay unique in the page: the copies get the colour's number
    n.querySelectorAll('[id]').forEach(function (el) { el.id = el.id + '-' + c.v; });
    n.querySelectorAll('[aria-labelledby]').forEach(function (el) {
      el.setAttribute('aria-labelledby', el.getAttribute('aria-labelledby').split(' ').map(function (t) { return t ? t + '-' + c.v : t; }).join(' '));
    });
    n.querySelectorAll('a[href*="/products/"]').forEach(function (a) {
      a.setAttribute('href', a.getAttribute('href').split('#')[0].split('?')[0] + '?variant=' + c.v);
    });
    var imgs = n.querySelectorAll('.card__media .media > img');
    if (imgs[0]) {
      var set = [165, 360, 533, 720, 940, 1066].filter(function (w) { return w < c.w; }).map(function (w) { return cdnWidth(c.i, w) + ' ' + w + 'w'; });
      set.push(c.i + ' ' + c.w + 'w');
      imgs[0].setAttribute('srcset', set.join(', '));
      imgs[0].setAttribute('src', cdnWidth(c.i, 533));
      imgs[0].setAttribute('alt', c.a || '');
      imgs[0].setAttribute('width', c.w);
      imgs[0].setAttribute('height', c.h);
    }
    // the hover photo is the product's second photo, often another colour: this card shows its own colour only
    for (var k = 1; k < imgs.length; k++) imgs[k].parentNode.removeChild(imgs[k]);
    n.querySelectorAll('.ns-card-swatches').forEach(function (s) { s.parentNode.removeChild(s); });
    n.querySelectorAll('.card__heading a').forEach(function (a) {
      var sp = document.createElement('span');
      sp.className = 'ns-card-colour';
      sp.textContent = ' – ' + c.c;
      a.appendChild(sp);
    });
    return n;
  }
  function expandColours(cards) {
    if (!splitOn()) return cards;
    var out = [];
    cards.forEach(function (li) {
      var d = splitData(li);
      if (d) { d.forEach(function (c) { out.push(colourCard(li, c)); }); return; }
      /* No colour thumbnails anywhere under a split pill (owner, 12 Oct 2026: "in all plaids filter i think we
         shouldnt show the thumbnails as you can already see all lose individual plaids"). A copy: the cached card
         keeps them for every other view. */
      if (li.querySelector('.ns-card-swatches')) {
        var n = li.cloneNode(true);
        n.querySelectorAll('.ns-card-swatches').forEach(function (s) { s.parentNode.removeChild(s); });
        out.push(n);
        return;
      }
      out.push(li);
    });
    return out;
  }
  // ---- Hidden review view (shows only the cross-collection block-list) ----
  function hiddenOn() { return filterState().hidden; }
  function setHidden(on) { invalidateState(); ssSet(HIDDEN_KEY, JSON.stringify({ h: curHandle(), on: !!on })); }
  function curateHidden(h) { return !!(h && window.NsCurate && NsCurate.isHidden && NsCurate.isHidden(h)); }
  function hiddenList() { return (window.NsCurate && NsCurate.list) ? NsCurate.list() : []; }
  function syncCurate() { if (window.NsCurate && NsCurate.refresh) NsCurate.refresh(); }
  // ---- Sale: cards carry data-ns-sale="1" (snippets/ns-product-on-sale) ----
  function saleOn() { return filterState().sale; }
  function setSale(on) { invalidateState(); ssSet(SALE_KEY, JSON.stringify({ h: curHandle(), on: !!on })); }
  function cardSale(li) { return li.getAttribute('data-ns-sale') === '1'; }
  function anyActive() { return favOn() || saleOn() || sizeSel().length > 0 || filterState().colour.length > 0 || hiddenOn(); }

  function grid() { return document.getElementById('product-grid'); }
  function gridContainer() { return document.getElementById('ProductGridContainer'); }
  function sectionId() { var g = grid(); return g ? g.getAttribute('data-id') : null; }
  function sizeEnabled() { return !!document.querySelector('[data-ns-size-filter]'); }

  function cardHandle(li) {
    var h = li.getAttribute('data-ns-card-handle');
    if (h) return h;
    var b = li.querySelector('[data-ns-fav-btn][data-product-handle]');
    if (b) return b.getAttribute('data-product-handle');
    var a = li.querySelector('a[href*="/products/"]');
    if (a) { var m = a.getAttribute('href').match(/\/products\/([^/?#]+)/); if (m) { try { return decodeURIComponent(m[1]); } catch (e) { return m[1]; } } }
    return null;
  }
  function cardSizes(li) { var v = li.getAttribute('data-ns-sizes'); return v ? v.split(',') : []; }
  function hasFav(h) { return !!(h && window.NsFavorites && NsFavorites.has && NsFavorites.has(h)); }

  function matches(li) { return passes(li, null); }
  /* passes(li, skip): does this card survive every active filter EXCEPT `skip`
     ('size' or 'colour')? The option counts use it, so each size / colour shows
     how many products it would give together with the OTHER filters (standard
     facet counts). Ignoring its own group matters: picking a second colour ADDS
     products, so a colour's count must not be narrowed by the colours already
     picked. The grid itself still uses matches() — every filter. */
  function passes(li, skip) {
    // One memoised read for the whole pass — see filterState() above.
    var st = filterState();
    var h = cardHandle(li);
    if (st.hidden) return curateHidden(h);      // Hidden view: show only hidden products
    if (curateHidden(h)) return false;          // every other view: hidden products never show
    if (st.fav && !hasFav(h)) return false;
    if (st.sale && skip !== 'sale' && !cardSale(li)) return false;
    var sel = skip === 'size' ? [] : st.size;
    if (sel.length) {
      var ss = cardSizes(li), ok = false;
      for (var i = 0; i < ss.length; i++) if (sel.indexOf(ss[i]) !== -1) { ok = true; break; }
      if (!ok) return false;
    }
    var cs = skip === 'colour' ? [] : st.colour;
    if (cs.length) {
      var cc = cardCols(li), hit = false;
      for (var j = 0; j < cc.length; j++) if (cs.indexOf(cc[j]) !== -1) { hit = true; break; }
      if (!hit) return false;
    }
    return true;
  }

  // ---- load every page of the current native view (cached per native query) ----
  var cache = { key: null, cards: null };
  function nativeKey() { var p = new URLSearchParams(location.search); p.delete('page'); p.delete('section_id'); return p.toString(); }
  function currentCards() { var out = [], g = grid(); if (g) g.querySelectorAll('li.grid__item').forEach(function (li) { out.push(li.cloneNode(true)); }); return out; }
  /* The live cards, uncloned. buildSizeOptions() only reads attributes, so
     deep-cloning every card on page load (currentCards) just to read two of
     them was pure waste. Never hand these to the cache or renderMatches. */
  function liveCards() { var g = grid(); return g ? Array.prototype.slice.call(g.querySelectorAll('li.grid__item')) : []; }
  /* Trust the number Liquid stamped on the grid before trusting the DOM.

     This used to read the pagination labels only. That works right up until
     lazy paging is on: ns-collection-lazy-pages rewrites those labels to VISUAL
     pages (2 Shopify pages per label) and deletes the in-between ones. On a
     9-page collection the scrape then returned 5, loadAll() fetched pages 1-5,
     and every product on Shopify pages 6-9 was missing from the filter cache —
     so filtering by size or favourites silently couldn't find them, and the
     size counts were wrong.

     data-ns-total-pages is rendered by Liquid from paginate.pages and is never
     touched by JS, which is exactly why it exists. The DOM scrape stays as the
     fallback for grids that predate the attribute. */
  function totalPages() {
    var g = grid();
    if (g) {
      var stamped = parseInt(g.getAttribute('data-ns-total-pages'), 10);
      if (stamped > 0) return stamped;
    }
    var nav = document.querySelector('#ProductGridContainer .pagination__list');
    if (!nav) return 1;
    var max = 1;
    nav.querySelectorAll('a, span').forEach(function (el) { var n = parseInt((el.textContent || '').trim(), 10); if (n > max) max = n; });
    return max;
  }
  function fetchPage(n) {
    var p = new URLSearchParams(location.search);
    p.set('section_id', sectionId());
    p.set('page', n);
    /* null, not [], when the page did not arrive (audit, 2 Oct 2026): a 429, a 5xx
       or a network error used to count as an empty page, and loadAll() cached
       the rest as the whole catalogue for as long as the view lasted. */
    return fetch(location.pathname + '?' + p.toString(), { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.ok ? r.text() : null; })
      .then(function (html) {
        if (html == null) return null;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var g = doc.getElementById('product-grid');
        if (!g) return null;
        var out = [];
        g.querySelectorAll('li.grid__item').forEach(function (li) { out.push(li); });
        return out;
      })
      .catch(function () { return null; });
  }
  /* The finished result is cached, but until this commit nothing tracked the
     fetch while it was STILL RUNNING. Three call sites can fire in the same
     tick — the size-filter open, the filter-form change and the idle primer —
     and each saw an empty cache and started its own full sweep. On a four-page
     collection that is twelve section requests where four would do, all of them
     racing to write the same cache.

     Holding the in-flight promise makes the later callers wait on the first
     one. Same result, same call sites, one sweep. */
  var inFlight = { key: null, promise: null };

  function loadAll() {
    var key = nativeKey();
    if (cache.key === key && cache.cards) return Promise.resolve(cache.cards);
    if (inFlight.key === key && inFlight.promise) return inFlight.promise;

    var pages = totalPages();
    if (pages <= 1) { var cards = currentCards(); cache = { key: key, cards: cards }; return Promise.resolve(cards); }
    var tasks = [];
    for (var n = 1; n <= pages; n++) tasks.push(fetchPage(n));

    var run = Promise.all(tasks).then(function (res) {
      var all = [], complete = true;
      res.forEach(function (cs) {
        if (cs == null) { complete = false; return; }
        cs.forEach(function (c) { all.push(c); });
      });
      /* Only a complete sweep, for the view still on screen, is cached: the
         shopper gets what did arrive, and the next tap asks again. A late sweep
         for a view already left no longer evicts the current one. */
      if (complete && key === nativeKey()) cache = { key: key, cards: all };
      if (inFlight.key === key) inFlight = { key: null, promise: null };
      return all;
    }).catch(function (e) {
      // Clear on failure too, or the key stays poisoned and every later call
      // returns the same rejected promise instead of retrying.
      if (inFlight.key === key) inFlight = { key: null, promise: null };
      throw e;
    });

    inFlight = { key: key, promise: run };
    return run;
  }

  /* ---- native-view snapshot (to restore when filters clear) ----
     Taken lazily, right before the first render that takes over the grid,
     not at page load: serialising the whole grid's innerHTML cost every
     collection visit, and most never touch a client-side filter. Every reader
     (updateCount, restoreCount, restoreNative) runs only after a takeover, so
     a snapshot always exists by then. Cleared wherever it used to be retaken
     (init, a native re-render), so the next takeover snapshots the new grid. */
  var snapshot = null, tookOver = false;
  function takeSnapshot() {
    var g = grid(); if (!g) return;
    snapshot = {
      gridHTML: g.innerHTML,
      countD: (document.getElementById('ProductCountDesktop') || {}).textContent || '',
      countM: (document.getElementById('ProductCount') || {}).textContent || ''
    };
  }

  function pagination() { var c = gridContainer(); return c ? c.querySelector('.pagination-wrapper') : null; }
  function setPaginationHidden(hide) { var p = pagination(); if (p) p.style.display = hide ? 'none' : ''; }

  /* The store's own words, printed on the grid by the section (audit, 2 Oct
     2026): this file used to carry English, and the count swapped the number
     into the plural sentence, so one match read "1 products" / "1 Produkte". */
  function gridText(name) { var g = grid(); return g ? g.getAttribute(name) || '' : ''; }
  function setCount(el, text, n) {
    if (!el) return;
    if (n == null) { el.textContent = text; return; }
    var one = gridText('data-ns-t-count-one'), other = gridText('data-ns-t-count-other');
    var s = String(text).trim(), m = s.match(/\d[\d.,]*/);
    var simple = !!(one && other && m && (s === other.replace(/\d+/, m[0]).trim() || s === one.replace(/\d+/, m[0]).trim()));
    if (simple) {
      // French counts 0 and 1 as singular.
      var single = n === 1 || (n === 0 && /^fr/i.test(document.documentElement.lang || ''));
      el.textContent = (single ? one : other).replace(/\d+/, String(n));
      return;
    }
    el.textContent = String(text).replace(/\d[\d.,]*/, String(n));
  }
  function updateCount(n) {
    if (!snapshot) return;
    setCount(document.getElementById('ProductCountDesktop'), snapshot.countD, n);
    setCount(document.getElementById('ProductCount'), snapshot.countM, n);
  }
  function restoreCount() {
    if (!snapshot) return;
    setCount(document.getElementById('ProductCountDesktop'), snapshot.countD, null);
    setCount(document.getElementById('ProductCount'), snapshot.countM, null);
  }

  function ensureEmpty(show) {
    var g = grid(); if (!g) return;
    var host = g.parentNode; if (!host) return;
    var el = host.querySelector('[data-ns-filter-empty]');
    if (show) {
      if (!el) { el = document.createElement('div'); el.setAttribute('data-ns-filter-empty', ''); el.className = 'ns-fav-filter-empty'; host.appendChild(el); }
      var msg = gridText('data-ns-t-empty') || 'No products match the selected filters.';
      if (hiddenOn()) { var rh = document.querySelector('[data-ns-hidden-filter][data-empty]'); if (rh) msg = rh.getAttribute('data-empty'); }
      else if (favOn()) { var r = document.querySelector('[data-ns-fav-filter][data-empty]'); if (r) msg = r.getAttribute('data-empty'); }
      else if (saleOn()) { var rs = document.querySelector('[data-ns-sale-filter][data-empty]'); if (rs) msg = rs.getAttribute('data-empty'); }
      el.textContent = msg;
      el.hidden = false;
    } else if (el) { el.hidden = true; }
  }

  function renderMatches(cards) {
    var g = grid(); if (!g) return;
    var frag = document.createDocumentFragment();
    cards.forEach(function (c) { frag.appendChild(document.importNode(c, true)); });
    g.innerHTML = '';
    g.appendChild(frag);
    ensureEmpty(cards.length === 0);
    if (window.NsFavorites && NsFavorites.sync) NsFavorites.sync();
    syncCurate(); // keep hidden cards display:none (overridden visible only in the Hidden view)
  }
  function restoreNative() {
    var g = grid(); if (!g || !snapshot) return;
    g.innerHTML = snapshot.gridHTML;
    ensureEmpty(false);
    setPaginationHidden(false);
    restoreCount();
    if (window.NsFavorites && NsFavorites.sync) NsFavorites.sync();
    syncCurate(); // re-hide blocked products in the restored native grid
  }

  // ---- control UI ----
  function updateFavUI() {
    var on = favOn();
    document.querySelectorAll('[data-ns-fav-filter-toggle]').forEach(function (t) { t.setAttribute('aria-pressed', on ? 'true' : 'false'); });
    document.querySelectorAll('[data-ns-fav-filter]').forEach(function (r) { r.classList.toggle('ns-fav-filter--active', on); });
  }
  function updateHiddenUI() {
    var on = hiddenOn();
    document.querySelectorAll('[data-ns-hidden-filter-toggle]').forEach(function (t) { t.setAttribute('aria-pressed', on ? 'true' : 'false'); });
    document.querySelectorAll('[data-ns-hidden-filter]').forEach(function (r) { r.classList.toggle('ns-hidden-filter--active', on); });
    document.body.classList.toggle('ns-show-hidden', on); // CSS reveals the normally display:none hidden cards
  }
  /* ---- Sale toggle ----
     The button only shows on collections that have sale items. Three sources
     answer that, from best to cheapest:
       1. every page is loaded (completeCards) — then it is exact, and the
          button also gets its count, following the other active filters;
       2. the collection.ns-sale view (checkSale) — whole collection, a few
          bytes per 250 products, cached for 15 minutes;
       3. the cards on this page.
     Liquid renders the button visible when this page has a sale item, so
     most collections never wait on the check. A Sale that is switched on
     always stays visible, so it can be switched off again. */
  var SALE_CHECK_KEY = 'northsheep_sale_check';
  var SALE_CHECK_TTL = 15 * 60 * 1000;
  var SALE_CHECK_MAX_PAGES = 8; // 2,000 products; past that the page's own cards decide
  var saleCheck = { key: null, n: null, promise: null };
  function saleRoots() { return document.querySelectorAll('[data-ns-sale-filter]'); }
  function saleCheckKey() { return curHandle() + '?' + nativeKey(); }
  function updateSaleUI() {
    var roots = saleRoots();
    if (!roots.length) return;
    var on = saleOn(), all = completeCards(), show, count = null;
    if (all) {
      var any = false, n = 0;
      all.forEach(function (li) {
        if (!cardSale(li)) return;
        any = true;
        if (passes(li, 'sale')) n++;
      });
      show = any || on;
      count = n;
    } else {
      show = on
        || (saleCheck.key === saleCheckKey() && saleCheck.n > 0)
        || liveCards().some(cardSale);
    }
    roots.forEach(function (root) {
      if (show) root.removeAttribute('hidden'); else root.setAttribute('hidden', '');
      root.classList.toggle('ns-sale-filter--active', on);
      var t = root.querySelector('[data-ns-sale-filter-toggle]');
      if (t) t.setAttribute('aria-pressed', on ? 'true' : 'false');
      var c = root.querySelector('[data-ns-sale-count]');
      if (c) c.textContent = count == null ? '' : ' (' + count + ')';
    });
  }
  function checkSale() {
    if (!saleRoots().length) return;
    var key = saleCheckKey();
    if (saleCheck.key === key && (saleCheck.n != null || saleCheck.promise)) { updateSaleUI(); return; }
    var cached = null;
    try { cached = JSON.parse(ssGet(SALE_CHECK_KEY) || 'null'); } catch (e) {}
    if (cached && cached.k === key && Date.now() - cached.t < SALE_CHECK_TTL) {
      saleCheck = { key: key, n: cached.n, promise: null };
      updateSaleUI();
      return;
    }
    /* THE PAGE USUALLY ANSWERS THIS ITSELF.

       Every card already carries data-ns-sale, written by the same snippet the
       ns-sale view uses — so a collection with a sale item in front of the
       shopper needs no request at all to prove one exists. Only ABSENCE has to
       be looked up, because the sale items could be sitting on page 3.

       The count is deliberately not taken from here: this page is one page of
       the collection, and the button shows the full number once the filter
       engine has loaded the whole thing. All this settles is "yes, there are
       some", which is what decides whether the button appears. */
    var onPage = 0;
    liveCards().forEach(function (li) { if (cardSale(li)) onPage++; });
    if (onPage > 0) {
      saleCheck = { key: key, n: onPage, promise: null };
      try { ssSet(SALE_CHECK_KEY, JSON.stringify({ k: key, n: onPage, t: Date.now() })); } catch (e) {}
      updateSaleUI();
      return;
    }

    var p = new URLSearchParams(location.search);
    p.delete('page'); p.delete('section_id'); p.set('view', 'ns-sale');
    function step(page) {
      p.set('page', page);
      return fetch(location.pathname + '?' + p.toString(), { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (j) {
          if (!j) return null;                       // unknown: leave it to the page's cards
          if (j.n > 0) return j.n;
          if (page < Math.min(j.pages || 1, SALE_CHECK_MAX_PAGES)) return step(page + 1);
          return 0;
        });
    }
    /* AND WHEN IT DOES HAVE TO ASK, NOT DURING THE LOAD.

       Nothing on screen is waiting for this: the Sale button simply is not
       drawn until the answer arrives, and a collection with no sale items
       never draws it at all. Run during load it competed with the grid for
       bandwidth on exactly the pages that are heaviest, and measured on the
       cowhide collection it was the first thing the page did after painting.

       Idle time instead — with a timer behind it, because requestIdleCallback
       is not called at all on a page the browser has decided not to paint
       (the same reason the restore loop cannot rely on rAF alone). */
    function soon(fn) {
      var done = false;
      var once = function () { if (!done) { done = true; fn(); } };
      if (window.requestIdleCallback) requestIdleCallback(once, { timeout: 2000 });
      setTimeout(once, 1200);
    }

    var run = new Promise(function (resolve) { soon(resolve); }).then(function () {
      return step(1);
    }).then(function (n) {
      if (saleCheck.key !== key) return;             // the shopper moved on meanwhile
      saleCheck = { key: key, n: n, promise: null };
      if (n != null) ssSet(SALE_CHECK_KEY, JSON.stringify({ k: key, n: n, t: Date.now() }));
      updateSaleUI();
    }).catch(function () {
      if (saleCheck.key === key) saleCheck = { key: key, n: null, promise: null };
    });
    saleCheck = { key: key, n: null, promise: run };
  }

  /* Colour pills: the pressed state is always painted; counts only from the
     WHOLE catalogue (same rule as the size counts - a page-1 count would
     understate every colour). */
  function updateColourUI(cards, complete) {
    var roots = document.querySelectorAll('[data-ns-colour-pills]');
    if (!roots.length) return;
    var sel = filterState().colour, tally = null;
    if (complete && cards) {
      tally = {};
      var sp = splitPills();
      cards.forEach(function (li) {
        if (!passes(li, 'colour')) return;       // counts follow the other active filters
        var d = splitData(li);
        cardCols(li).forEach(function (h) {
          // a split pill counts the cards it will show: one per colour
          if (h) tally[h] = (tally[h] || 0) + (d && sp.indexOf(h) !== -1 ? d.length : 1);
        });
      });
    }
    roots.forEach(function (root) {
      var counts = root.hasAttribute('data-counts');
      root.querySelectorAll('[data-ns-colour-pill]').forEach(function (b) {
        var h = b.getAttribute('data-ns-colour-pill');
        b.setAttribute('aria-pressed', sel.indexOf(h) !== -1 ? 'true' : 'false');
        if (tally) {
          var none = !tally[h], on = sel.indexOf(h) !== -1;
          b.classList.toggle('ns-colour-pill--empty', none);
          /* 0 products together with the other filters: not clickable, so it
             can't lead to an empty grid — unless it is already selected, then
             it must stay clickable so it can be turned off again. */
          if (none && !on) b.setAttribute('aria-disabled', 'true');
          else b.removeAttribute('aria-disabled');
          var c = b.querySelector('[data-ns-colour-count]');
          if (c && counts) c.textContent = String(tally[h] || 0);
        } else {
          b.removeAttribute('aria-disabled'); // counts not known yet: never block a click
        }
      });
      var clr = root.querySelector('[data-ns-colour-clear]');
      if (clr) clr.hidden = sel.length === 0;
      /* Keep the first selected pill in view (e.g. a colour restored from the
         session that sits past the phone's edge). Scroll the ROW only —
         scrollIntoView would also move the page. The old "× Clear" pill that
         used to push the row right is gone; the 16px just keeps a little air. */
      var track = root.querySelector('.ns-colour-pills__track');
      var firstOn = root.querySelector('[data-ns-colour-pill][aria-pressed="true"]');
      if (track && firstOn) {
        var tl = track.getBoundingClientRect().left, fl = firstOn.getBoundingClientRect().left;
        if (fl < tl || fl + firstOn.offsetWidth > tl + track.clientWidth) track.scrollLeft += (fl - tl) - 16;
      }
      root.classList.toggle('ns-colour-pills--active', sel.length > 0);
    });
    updateColourFade();
  }
  function completeCards() { return (cache.cards && cache.key === nativeKey()) ? cache.cards : null; }
  // Edge fade on the pill row, only on a side that actually has more pills.
  function updateColourFade() {
    document.querySelectorAll('.ns-colour-pills__track').forEach(function (t) {
      var max = t.scrollWidth - t.clientWidth;
      t.classList.toggle('is-fade-end', max > 2 && t.scrollLeft < max - 2);
      t.classList.toggle('is-fade-start', max > 2 && t.scrollLeft > 2);
    });
  }
  /* `complete` says whether `cards` is the WHOLE collection or just the page
     currently in the DOM. Counts are only rendered when it's the whole thing —
     a count taken from page 1 would understate every size and read as a bug. */
  function buildSizeOptions(cards, complete) {
    var set = {}, typeOf = {}, tally = {};
    (cards || []).forEach(function (li) {
      var ty = li.getAttribute('data-ns-sizetype') || '';
      // Every size stays listed (set), but only cards that pass the OTHER active
      // filters (colour, favourites) are counted — see passes().
      var counted = passes(li, 'size');
      cardSizes(li).forEach(function (s) {
        if (!s) return;
        set[s] = true;
        if (counted) tally[s] = (tally[s] || 0) + 1;
        if (ty && !typeOf[s]) typeOf[s] = ty;
      });
    });
    var sizes = [];
    ORDER.forEach(function (s) { if (set[s]) sizes.push(s); });
    var sel = sizeSel();
    document.querySelectorAll('[data-ns-size-filter]').forEach(function (root, r) {
      var ul = root.querySelector('[data-ns-size-options]'), tmpl = root.querySelector('[data-ns-size-template]');
      if (!ul || !tmpl) return;
      // Counts are part of the signature, so the list rebuilds when they arrive.
      var want = sizes.map(function (s) {
        return s + ':' + (typeOf[s] || '') + ':' + (complete ? (tally[s] || 0) : '');
      }).join(',');
      if (ul.getAttribute('data-ns-built') !== want) {
        ul.innerHTML = '';
        sizes.forEach(function (s) {
          var node = tmpl.content ? tmpl.content.cloneNode(true) : null;
          if (!node) return;
          var input = node.querySelector('[data-ns-size-toggle]'), lbl = node.querySelector('[data-ns-size-label]'), label = node.querySelector('label');
          if (input) { input.value = s; var id = 'NsSize-' + s + '-' + r; input.id = id; if (label) label.setAttribute('for', id); }
          if (lbl) lbl.textContent = sizeDisplay(s, typeOf[s]);
          /* The count sits directly after the label text, inside
             .facet-checkbox__text.

             Putting it on the <li> instead pushed it to the far right of the
             row, because the label stretches to fill the flex row — it read as
             a stray number rather than part of the option. Inside the text
             wrapper it simply follows the words. (The alignment problem this
             was moved to avoid turned out to be the display:flex override I'd
             added to the label, since removed — not the element's position.) */
          if (complete && lbl && lbl.parentNode) {
            var n = document.createElement('span');
            n.className = 'ns-size-filter__count';
            n.textContent = tally[s] || 0;
            lbl.parentNode.appendChild(n);
          }
          ul.appendChild(node);
        });
        ul.setAttribute('data-ns-built', want);
      }
      ul.querySelectorAll('[data-ns-size-toggle]').forEach(function (i) {
        i.checked = sel.indexOf(i.value) !== -1;
        /* With the whole catalogue loaded, a size with 0 products (given the
           other filters) can't be ticked — unless it is ticked already, so it
           can always be unticked. Page-only (partial) data never disables. */
        var dead = !!complete && !tally[i.value] && !i.checked;
        i.disabled = dead;
        var li = i.closest('li');
        if (li) li.classList.toggle('ns-size-option--empty', dead);
      });
      if (sizes.length) root.removeAttribute('hidden'); else root.setAttribute('hidden', '');
      root.classList.toggle('ns-size-filter--active', sel.length > 0);
      var c = root.querySelector('[data-ns-size-count]'); if (c) c.textContent = sel.length ? sel.length + ' selected' : '';
    });
  }

  // ---- pills ----
  function labelOf(sel) { var el = document.querySelector(sel); return el ? (el.textContent || '').trim() : ''; }
  function clearPills() { document.querySelectorAll('[data-ns-pill]').forEach(function (p) { p.remove(); }); }
  /* Inside of one active-filter chip. "Size: XXL" becomes a quiet "Size" prefix
     plus the value; a colour chip borrows its pill's swatch photo. */
  function chipInner(it) {
    var parts = String(it.label).split(': ');
    var key = parts.length > 1 ? parts.shift() : '';
    var html = '';
    if (it.t === 'colour') {
      document.querySelectorAll('[data-ns-colour-pill]').forEach(function (b) {
        if (html || b.getAttribute('data-ns-colour-pill') !== it.v) return;
        var img = b.querySelector('img');
        if (img) html = '<img class="ns-chip__swatch" src="' + esc(img.currentSrc || img.src) + '" alt="" width="22" height="22">';
      });
    }
    if (key) html += '<span class="ns-chip__key">' + esc(key) + '</span>';
    return html + '<span class="ns-chip__label">' + esc(parts.join(': ')) + '</span>';
  }
  /* NOTE: do not "compensate" for the filter bar changing height here.

     The first hide adds the "Reset hidden" pill, the bar above the grid gains
     a row, and every card's offsetTop moves down 86px. That looks alarming in
     a measurement, but offsetTop is document-relative: the browser's own
     scroll anchoring already holds the viewport still when content above it
     grows, so nothing actually moves on screen.

     Adding a window.scrollBy here to "fix" it stacked a second correction on
     top of the browser's, and the page crept downward on every single hide. */
  function renderPills() {
    clearPills();
    var items = [], sizeLbl = labelOf('[data-ns-size-filter] .facets__summary-label, [data-ns-size-filter] summary span') || 'Size';
    if (saleOn()) { var sr = document.querySelector('[data-ns-sale-filter][data-label]'); items.push({ t: 'sale', v: '', label: sr ? sr.getAttribute('data-label') : 'Sale' }); }
    sizeSel().forEach(function (s) { items.push({ t: 'size', v: s, label: sizeLbl + ': ' + s }); });
    if (favOn()) { var favLbl = labelOf('[data-ns-fav-filter] .facets__summary-label, [data-ns-fav-filter] summary span') || 'Favourites'; items.push({ t: 'fav', v: '', label: favLbl }); }
    if (hiddenOn()) { var hidLbl = labelOf('[data-ns-hidden-filter] .facets__summary-label, [data-ns-hidden-filter] summary span') || 'Hidden'; items.push({ t: 'hidden', v: '', label: hidLbl }); }
    filterState().colour.forEach(function (hc) {
      var pb = null;
      document.querySelectorAll('[data-ns-colour-pill]').forEach(function (b) { if (!pb && b.getAttribute('data-ns-colour-pill') === hc) pb = b; });
      items.push({ t: 'colour', v: hc, label: pb ? (pb.getAttribute('data-label') || hc) : hc });
    });
    // "Reset hidden (N)" — un-hide everything in one tap; shows whenever products are hidden.
    var nHidden = hiddenList().length;
    if (nHidden > 0) items.push({ t: 'reset-hidden', v: '', label: (gridText('data-ns-t-reset-hidden') || 'Reset hidden ([count])').replace('[count]', nHidden), reset: true });
    if (!items.length) return;
    document.querySelectorAll('.active-facets-desktop, .active-facets-mobile').forEach(function (host) {
      items.forEach(function (it) {
        try {
          // Build the <facet-remove> inside an inert <template> so its <a> child
          // exists BEFORE the custom-element upgrade runs. Dawn's FacetRemove
          // constructor does `this.querySelector('a').setAttribute(...)`, so an
          // empty element created with document.createElement('facet-remove')
          // throws (setAttribute on null) and aborts the whole pill render —
          // which broke "Remove all". A template keeps the element inert until
          // it's inserted (with children present), so the upgrade succeeds.
          var tpl = document.createElement('template');
          tpl.innerHTML = '<facet-remove data-ns-pill>' +
            '<a href="#" class="active-facets__button active-facets__button--light' + (it.reset ? ' ns-pill--reset' : '') + '" data-ns-pill-remove="' + it.t + '" data-ns-pill-val="' + esc(it.v) + '">' +
            '<span class="active-facets__button-inner button button--tertiary">' + chipInner(it) +
            '<span class="svg-wrapper">' + CLOSE_SVG + '</span></span></a></facet-remove>';
          var wrap = tpl.content.firstElementChild;
          var rm = host.querySelector('.active-facets__button-wrapper');
          if (rm) host.insertBefore(wrap, rm); else host.appendChild(wrap);
        } catch (e) { /* never let one pill abort the clear/apply flow */ }
      });
    });
  }

  /* ONE MARKER FOR "THE THEME'S OWN FILTER HAS THE GRID" (audit, 2 Oct 2026).
     Other scripts guessed from class names nothing set (the product page counter
     said "3 of 361" under a Size, Sale or colour filter), and the native colour
     pills could not know their Shopify counts no longer applied. */
  function markClient(on) { if (document.body) document.body.classList.toggle('ns-client-filter-on', !!on); }

  // ---- main ----
  var applyGen = 0;
  function apply() {
    var gen = ++applyGen;
    if (hiddenOn() && hiddenList().length === 0) setHidden(false); // nothing left hidden -> leave the view
    updateFavUI();
    updateHiddenUI();
    updateSaleUI();
    if (!anyActive()) {
      if (tookOver) {
        restoreNative();
        tookOver = false;
        markClient(false);
        // restoreNative() replays a snapshot taken at page load — one batch of
        // products, before lazy paging appended the rest. Without this, clearing
        // a filter (or the "Reset hidden" pill, which comes through here too)
        // leaves the page at half its products. Promos re-place themselves off
        // the resulting grid mutation.
        if (window.NsLazyPages && NsLazyPages.refill) NsLazyPages.refill();
      }
      renderPills(); // may still show the "Reset hidden" pill
      if (sizeEnabled()) loadAll().then(function (c) { buildSizeOptions(c, true); });
      updateColourUI(completeCards(), !!completeCards());
      updateSaleUI();
      return;
    }
    var key = nativeKey();
    loadAll().then(function (cards) {
      /* ONLY THE LATEST REQUEST IS DRAWN (audit, 2 Oct 2026). A pill, Favourites
         or Sale switched on and off again while the first full sweep was loading
         used to paint the "on" answer anyway, with nothing selected: every product
         of every page in one grid, pagination hidden. A sort meanwhile painted the
         old view's cards under the new address. Every apply() takes a number; an
         answer for an older one, or for another view, is dropped. */
      if (gen !== applyGen || key !== nativeKey() || !anyActive()) return;
      buildSizeOptions(cards, true);
      updateColourUI(cards, true);
      updateSaleUI();
      var matching = expandColours(cards.filter(matches)); // one card per colour under a split pill (see splitPills)
      if (!snapshot) takeSnapshot(); // still the native grid: nothing has taken it over yet
      renderMatches(matching);
      setPaginationHidden(true);
      updateCount(matching.length);
      renderPills();
      tookOver = true;
      markClient(true);
    });
  }

  /* A PILL FROM THE ADDRESS (owner, 12 Oct 2026: "for specific plaid searches the main collection as landing page with
     active plaid filter"). ?pill=<colour collection handle> switches that pill on, as a tap would, then leaves the
     address so the pill behaves like any other from here on (off, reload, Back). An unknown or link pill: ignored. */
  var pillFromUrlDone = false;
  function pillFromUrl() {
    if (pillFromUrlDone) return;
    pillFromUrlDone = true;
    var p = new URLSearchParams(location.search), h = p.get('pill');
    if (!h) return;
    p.delete('pill');
    try { history.replaceState(history.state, '', location.pathname + (p.toString() ? '?' + p.toString() : '') + location.hash); } catch (e) {}
    var b = null;
    document.querySelectorAll('button[data-ns-colour-pill]').forEach(function (x) { if (x.getAttribute('data-ns-colour-pill') === h) b = x; });
    if (!b) return;
    setFav(false); setSale(false); setSize([]); setHidden(false);
    setColour([h]);
  }

  function init() {
    if (!grid()) return;
    pillFromUrl();
    snapshot = null; // taken on the first takeover — see the snapshot note above
    updateFavUI();
    updateHiddenUI();
    updateColourUI(completeCards(), !!completeCards());
    updateSaleUI();
    checkSale();
    // Partial options from the current page now; the full set loads lazily when
    // the shopper opens the Size dropdown or applies a filter (avoids fetching
    // every page on each collection page-load).
    if (sizeEnabled()) buildSizeOptions(liveCards());
    if (anyActive()) apply();
    else if (hiddenList().length > 0) renderPills(); // surface "Reset hidden" on load
  }

  // ---- events (capture phase so Dawn's facet form never auto-submits) ----
  // Favourites toggle (a <summary>; preventDefault stops it opening, stopPropagation stops MenuDrawer).
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('[data-ns-fav-filter-toggle]') : null;
    if (btn) { e.preventDefault(); e.stopPropagation(); var fon = !favOn(); if (fon) setHidden(false); setFav(fon); apply(); return; }
    var sbtn = e.target && e.target.closest ? e.target.closest('[data-ns-sale-filter-toggle]') : null;
    if (sbtn) { e.preventDefault(); e.stopPropagation(); var son = !saleOn(); if (son) setHidden(false); setSale(son); apply(); return; }
    var hbtn = e.target && e.target.closest ? e.target.closest('[data-ns-hidden-filter-toggle]') : null;
    if (hbtn) { e.preventDefault(); e.stopPropagation(); var hon = !hiddenOn(); if (hon) { setFav(false); setSale(false); setSize([]); setColour([]); } setHidden(hon); apply(); return; }
    var cpill = e.target && e.target.closest ? e.target.closest('[data-ns-colour-pill]') : null;
    if (cpill) {
      e.preventDefault(); e.stopPropagation();
      var ch = cpill.getAttribute('data-ns-colour-pill'), csel = colourSel(), ci = csel.indexOf(ch);
      if (ci === -1 && cpill.getAttribute('aria-disabled') === 'true') return; // 0 products: no dead end
      if (ci === -1) { csel.push(ch); setHidden(false); } else csel.splice(ci, 1);
      setColour(csel); apply();
      return;
    }
    var cclr = e.target && e.target.closest ? e.target.closest('[data-ns-colour-clear]') : null;
    if (cclr) { e.preventDefault(); e.stopPropagation(); setColour([]); apply(); return; }
    var pill = e.target && e.target.closest ? e.target.closest('[data-ns-pill-remove]') : null;
    if (pill) {
      e.preventDefault(); e.stopPropagation();
      var ty = pill.getAttribute('data-ns-pill-remove'), val = pill.getAttribute('data-ns-pill-val');
      if (ty === 'size') setSize(sizeSel().filter(function (s) { return s !== val; }));
      if (ty === 'fav') setFav(false);
      if (ty === 'sale') setSale(false);
      if (ty === 'hidden') setHidden(false);
      if (ty === 'colour') setColour(colourSel().filter(function (c) { return c !== val; }));
      if (ty === 'reset-hidden') { setHidden(false); if (window.NsCurate && NsCurate.reset) NsCurate.reset(); }
      apply();
      return;
    }
    var clr = e.target && e.target.closest ? e.target.closest('[data-ns-size-clear]') : null;
    if (clr) { e.preventDefault(); e.stopPropagation(); setSize([]); apply(); return; }
    // Native "Remove all" — drop the custom filters AND bring back any hidden
    // products, so it's a true "everything back to normal" (same effect as the
    // "Reset hidden" pill, plus fav/size). Always render so the view + pills
    // update immediately even when a sort/param is in the URL (nativeKey truthy,
    // which previously skipped the client-side apply and left it looking broken).
    var rmAll = e.target && e.target.closest ? e.target.closest('.active-facets__button-remove, .mobile-facets__clear, .facets__reset') : null;
    if (rmAll) {
      setFav(false); setSale(false); setSize([]); setColour([]); setHidden(false);
      if (window.NsCurate && NsCurate.reset) NsCurate.reset();
      apply();
      if (!nativeKey()) e.preventDefault();
    }
  }, true);

  // Size checkboxes: block the 'input' (auto-submit) and toggle on 'change'.
  document.addEventListener('input', function (e) {
    var t = e.target;
    if (t && t.matches && t.matches('[data-ns-size-toggle]')) e.stopPropagation();
  }, true);
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t && t.matches && t.matches('[data-ns-size-toggle]')) { e.stopPropagation(); var s = t.value, sel = sizeSel(); var i = sel.indexOf(s); if (i === -1) { sel.push(s); setHidden(false); } else sel.splice(i, 1); setSize(sel); apply(); }
  }, true);

  // Heart toggled on a card / drawer -> favourites set changed; re-apply.
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (t && t.closest && (t.closest('[data-ns-fav-btn]') || t.closest('[data-ns-fav-remove]'))) {
      setTimeout(function () { if (favOn()) apply(); else updateFavUI(); }, 30);
    }
    // Opening the Size dropdown lazily loads every page so the size list is
    // complete (not just the current page). Cached per native query.
    /* Load every page (so the size list AND its counts are the real totals)
       as soon as the shopper goes anywhere near the filters.

       This used to listen only for '[data-ns-size-filter] summary', which the
       mobile drawer never matches — it opens the panel through its own control
       outside that element. So on a phone the counts only appeared after
       actually ticking a size, which is exactly when they stop being useful.
       Any click inside the size filter, or on a mobile facets opener, now
       primes it. loadAll() is cached per query, so extra calls are free. */
    if (t && t.closest && (
      t.closest('[data-ns-size-filter]')
      || t.closest('.mobile-facets__open, .mobile-facets__opener, [data-ns-size-filter-open]')
    )) {
      loadAll().then(function (c) { buildSizeOptions(c, true); });
    }
  });

  // The hidden block-list changed (hide/unhide/reset from the curate engine) ->
  // refresh the Hidden view, the live count and the "Reset hidden" pill.
  document.addEventListener('ns:hidden-changed', function () {
    updateHiddenUI();
    if (anyActive()) apply();
    else { clearPills(); if (hiddenList().length > 0) renderPills(); }
  });

  /* Colour counts need every page, so load them the moment a shopper reaches
     for the pill row (hover, focus or touch) - never on page load, which would
     fetch the whole catalogue for every visitor. loadAll() is cached per query. */
  var colourPrimed = false;
  function primeColours(e) {
    if (colourPrimed) return;
    var t = e.target;
    if (!(t && t.closest && t.closest('[data-ns-colour-pills]'))) return;
    colourPrimed = true;
    loadAll().then(function (c) { updateColourUI(c, true); });
  }
  document.addEventListener('pointerover', primeColours, { passive: true });
  document.addEventListener('focusin', primeColours);
  document.addEventListener('touchstart', primeColours, { passive: true });
  /* The Sale count needs every page too: same rule, primed when a shopper
     reaches for the button (or opens the mobile filter drawer it lives in). */
  var salePrimed = false;
  function primeSale(e) {
    if (salePrimed) return;
    var t = e.target;
    if (!(t && t.closest && (t.closest('[data-ns-sale-filter]') || t.closest('.mobile-facets__open, .mobile-facets__opener')))) return;
    if (!saleRoots().length) return;
    salePrimed = true;
    loadAll().then(function () { updateSaleUI(); });
  }
  document.addEventListener('pointerover', primeSale, { passive: true });
  document.addEventListener('focusin', primeSale);
  document.addEventListener('touchstart', primeSale, { passive: true });
  document.addEventListener('scroll', function (e) {
    if (e.target && e.target.classList && e.target.classList.contains('ns-colour-pills__track')) updateColourFade();
  }, { capture: true, passive: true });
  window.addEventListener('resize', updateColourFade);

  /* Desktop browsing of the pill row (owner, 2026-09-15). A mouse cannot swipe,
     so (1) click-and-drag scrolls the row, and (2) resting the pointer near
     either end glides it that way, faster the closer to the edge. Mouse only —
     touch keeps its native swipe. A drag of more than 5px swallows the click
     that follows, so letting go over a pill doesn't toggle it; that listener
     sits on WINDOW in the capture phase so it runs before the pill toggle
     (which listens on document). The glide stops at the end of the row and is
     skipped for prefers-reduced-motion (dragging still works). */
  var PILL_EDGE = 90, PILL_EDGE_MAX = 8;
  var pillDrag = null, pillSwallowClick = false, pillEdge = { track: null, v: 0, raf: 0 };
  function pillTrackOf(t) { return t && t.closest ? t.closest('.ns-colour-pills__track') : null; }
  function pillOverflows(tr) { return tr.scrollWidth - tr.clientWidth > 2; }
  function stopPillEdge() { pillEdge.v = 0; if (pillEdge.raf) cancelAnimationFrame(pillEdge.raf); pillEdge.raf = 0; }
  function pillEdgeStep() {
    var e = pillEdge;
    if (!e.track || !e.v) { e.raf = 0; return; }
    var before = e.track.scrollLeft;
    e.track.scrollLeft += e.v;
    updateColourFade();
    if (e.track.scrollLeft === before) { e.raf = 0; return; } // reached the end
    e.raf = requestAnimationFrame(pillEdgeStep);
  }
  document.addEventListener('pointerdown', function (e) {
    pillSwallowClick = false;
    if (e.pointerType !== 'mouse' || e.button !== 0) return;
    var tr = pillTrackOf(e.target);
    if (!tr || !pillOverflows(tr)) return;
    stopPillEdge();
    pillDrag = { track: tr, x: e.clientX, left: tr.scrollLeft, moved: false, id: e.pointerId };
  });
  document.addEventListener('pointermove', function (e) {
    if (e.pointerType !== 'mouse') return;
    if (pillDrag) {
      var dx = e.clientX - pillDrag.x;
      if (!pillDrag.moved && Math.abs(dx) > 5) {
        pillDrag.moved = true;
        pillDrag.track.classList.add('is-dragging');
        try { pillDrag.track.setPointerCapture(pillDrag.id); } catch (err) {}
      }
      if (pillDrag.moved) { pillDrag.track.scrollLeft = pillDrag.left - dx; updateColourFade(); }
      return;
    }
    var tr = pillTrackOf(e.target);
    if (!tr || !pillOverflows(tr) || matchMedia('(prefers-reduced-motion: reduce)').matches) { stopPillEdge(); return; }
    var r = tr.getBoundingClientRect(), v = 0;
    if (e.clientX > r.right - PILL_EDGE) v = Math.ceil(PILL_EDGE_MAX * (e.clientX - (r.right - PILL_EDGE)) / PILL_EDGE);
    else if (e.clientX < r.left + PILL_EDGE) v = -Math.ceil(PILL_EDGE_MAX * ((r.left + PILL_EDGE) - e.clientX) / PILL_EDGE);
    pillEdge.track = tr;
    pillEdge.v = v;
    if (!v) stopPillEdge();
    else if (!pillEdge.raf) pillEdge.raf = requestAnimationFrame(pillEdgeStep);
  }, { passive: true });
  function endPillDrag() {
    if (!pillDrag) return;
    if (pillDrag.moved) { pillSwallowClick = true; pillDrag.track.classList.remove('is-dragging'); }
    pillDrag = null;
  }
  document.addEventListener('pointerup', endPillDrag);
  document.addEventListener('pointercancel', endPillDrag);
  document.addEventListener('pointerout', function (e) {
    if (e.pointerType === 'mouse' && pillTrackOf(e.target) && !pillTrackOf(e.relatedTarget)) stopPillEdge();
  }, { passive: true });
  window.addEventListener('click', function (e) {
    if (!pillSwallowClick) return;
    pillSwallowClick = false;
    if (pillTrackOf(e.target)) { e.preventDefault(); e.stopPropagation(); }
  }, true);
  document.addEventListener('dragstart', function (e) { if (pillTrackOf(e.target)) e.preventDefault(); });

  // Native re-render (sort/filter/pagination) replaces #product-grid -> reset + re-apply.
  var moT = null;
  function onNativeRender() {
    cache.key = null;          // native result set changed
    snapshot = null;           // retaken on the next takeover, from this new grid
    tookOver = false;
    markClient(false);         // the new native grid is Shopify's until apply() takes it again
    updateFavUI();
    updateHiddenUI();
    colourPrimed = false;       // the native result set changed, so counts must reload
    salePrimed = false;
    updateColourUI(null, false);
    updateSaleUI();
    checkSale();                // a native filter can add or remove every sale item
    syncCurate(); // the new native grid needs blocked products re-hidden
    if (anyActive()) apply();
    else { clearPills(); if (hiddenList().length > 0) renderPills(); if (sizeEnabled()) buildSizeOptions(liveCards()); }
  }
  if (window.MutationObserver) {
    var mo = new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var nodes = muts[i].addedNodes;
        for (var j = 0; j < nodes.length; j++) {
          var nd = nodes[j];
          if (nd.nodeType !== 1) continue;
          if (nd.id === 'product-grid' || (nd.querySelector && nd.querySelector('#product-grid'))) {
            clearTimeout(moT); moT = setTimeout(onNativeRender, 60);
            return;
          }
        }
      }
    });
    try { mo.observe(document.documentElement, { childList: true, subtree: true }); } catch (e) {}
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
